import React, { useEffect, useState } from 'react'
import { useTalentApi } from '../../store/mainContext'

const RemoteValue = ({ collection, id, showLoading, predicate }) => {
  const api = useTalentApi()
  const [loading, setLoading] = useState(showLoading)
  const [value, setValue] = useState()

  predicate = predicate || ((x) => x.text)

  useEffect(() => {
    if (!id) {
      setValue()
      setLoading(false)
      return
    }
    api
      .get(`${collection}/${id}`)
      .then(({ data }) => setValue(data))
      .finally(() => setLoading(false))
  }, [api, collection, id])

  if (loading) {
    return <React.Fragment>Trying to remember...</React.Fragment>
  }

  if (!value) return <React.Fragment></React.Fragment>

  return <React.Fragment>{predicate(value)}</React.Fragment>
}

export default RemoteValue
